// Static lookup tables for DutyLog Enhancement
// Ported from proven research data: abbreviation-dictionary.json

export const abbreviationDictionary = {
  "common_typos": {
    "dechcho": "Deh Cho",
    "Dehcho": "Deh Cho"
  },
  "aircraft_codes": {
    "R/W": "Helicopter",
    "F/W": "Fixed Wing",
    "TPU": "Fixed Wing Aircraft",
    "DAO": "Helicopter Delta Alpha Oscar",
    "AVQ": "Helicopter Alpha Victor Quebec",
    "PJJ": "Helicopter Papa Juliet Juliet", 
    "DCV": "Helicopter Delta Charlie Victor",
    "UFS": "Helicopter Uniform Foxtrot Sierra",
    "HON": "Helicopter Hotel Oscar November",
    "HMZ": "Helicopter Hotel Mike Zulu",
    "IUX": "Helicopter India Uniform X-ray",
    "NZM": "Helicopter November Zulu Mike",
    "FINV": "Helicopter Foxtrot India November Victor",
    "INV": "Helicopter India November Victor",
    "DRH": "Helicopter Delta Romeo Hotel",
    "TEK": "Helicopter Tango Echo Kilo",
    "CHH": "Helicopter Charlie Hotel Hotel",
    "BUC": "Helicopter Bravo Uniform Charlie"
  },
  "aircraft_classes": {
    "med": "Medium Helicopter",
    "int": "Intermediate Helicopter",
    "light": "Light Helicopter",
    "heavy": "Heavy Helicopter"
  },
  "aircraft_fleets": {
    "802s": "Air Tractor AT802 Fire Boss Tanker Group (800 gallons)",
    "215s": "Canadair CL-215 Scooper Tanker Group (1500 gallons)", 
    "415s": "Canadair CL-415 Super-Scooper Tanker Group (1600 gallons)",
    "Electra": "Air Spray L-188 ELECTRA Heavy Tanker (3000 gallons)",
    "electra": "Air Spray L-188 ELECTRA Heavy Tanker (3000 gallons)"
  },
  "aviation_fuel": {
    "Jet A": "Aviation Turbine Fuel",
    "Jet A-1": "Aviation Turbine Fuel (International Standard)",
    "Jet B": "Wide-Cut Aviation Turbine Fuel",
    "Avgas": "Aviation Gasoline",
    "100LL": "Low-Lead Aviation Gasoline",
    "R/W": "Rotary Wing"
  },
  "personnel_roles": {
    "RDO": "Regional Duty Officer",
    "RDOFS": "Regional Duty Officer Dehcho",
    "RDOEV": "Regional Duty Officer Beaufort Delta",
    "RDOZF": "Regional Duty Officer North Slave",
    "RDOSM": "Regional Duty Officer South Slave",
    "RDOVQ": "Regional Duty Officer Sahtu",
    "ZFDO": "North Slave Regional Duty Officer",
    "ZFRDO": "North Slave Regional Duty Officer",
    "TDO": "Territorial Duty Officer", 
    "TEMO": "Territorial Emergency Measures Officer",
    "HYADO": "Hay River Area Duty Officer",
    "SMADO": "Fort Smith Area Duty Officer",
    "IC": "Incident Commander",
    "ARIC": "Assistant Regional Information Coordinator",
    "PSC": "Plans Section Chief",
    "OSC": "Operations Section Chief",
    "LOGS": "Logistics Section Chief",
    "EFF": "Extra Fire Fighter",
    "IGSP": "Ignition Specialist",
    "FT": "Fire Technician",
    "LDO": "Logistics Duty Officer",
    "DO": "Duty Officer"
  },
  "common_abbreviations": {
    "IA": "Initial Attack",
    "LA": "Limited Action",
    "SA": "Suppression Action",
    "DA": "Detailed Attack",
    "AB": "Abandoned",
    "UC": "Under Control",
    "OC": "Out of Control",
    "BH": "Being Held",
    "BM": "Being Monitored",
    "BP": "Being Prepared",
    "EX": "Extinguished",
    "VAR": "Values At Risk",
    "FMD": "Forest Management Division",
    "GNWT": "Government of the Northwest Territories",
    "CFFDRS": "Canadian Forest Fire Danger Rating System",
    "VIIRS": "Visible Infrared Imaging Radiometer Suite",
    "AWOL": "Away Without Leave",
    "EFFs": "Extra Fire Fighters",
    "viz": "Visibility",
    "K report": "Smoke Report",
    "k report": "Smoke Report",
    "sk report": "Smoke Report",
    "YK": "Yellowknife",
    "viirs hit": "VIIRS hotspot detection",
    "nnw": "north-northwest",
    "nne": "north-northeast",
    "ssw": "south-southwest",
    "sse": "south-southeast",
    "nw": "northwest",
    "ne": "northeast",
    "sw": "southwest",
    "se": "southeast",
    "atm": "at the moment",
    "asap": "as soon as possible",
    "ETA": "Estimated Time of Arrival",
    "OPS": "Operations",
    "comms": "communications",
    "temps": "temperatures",
    "medivac": "medical evacuation"
  },
  "systems": {
    "SPARCS": "Spatial Precipitation and Climate Resource Centre System",
    "VIIRS": "Visible Infrared Imaging Radiometer Suite",
    "IntelliFire": "Integrated Fire Management Information System",
    "EMBER": "NWT Financial Decision Support System",
    "Ember": "NWT Financial Decision Support System",
    "ember": "NWT Financial Decision Support System"
  },
  "organizations": {
    "GNWT": "Government of the Northwest Territories",
    "ECC": "Environment and Climate Change",
    "FMD": "Forest Management Division",
    "HQ": "Headquarters",
    "MACA": "Municipal and Community Affairs",
    "EMO": "Emergency Management Organization",
    "INF": "Infrastructure Department",
    "CIFFC": "Canadian Interagency Forest Fire Centre",
    "CFS": "Canadian Forest Service",
    "GSH": "Great Slave Helicopters"
  },
  "region_codes": {
    "EV": "Beaufort Delta",
    "VQ": "Sahtu",
    "SM": "South Slave", 
    "ZF": "North Slave",
    "FS": "Dehcho",
    "WB": "Wood Buffalo National Park"
  },
  "location_codes": {
    "EV": "Inuvik",
    "YEV": "Inuvik",
    "CYEV": "Inuvik",
    "VQ": "Norman Wells",
    "YVQ": "Norman Wells",
    "CYVQ": "Norman Wells",
    "SM": "Fort Smith",
    "YSM": "Fort Smith",
    "CYSM": "Fort Smith",
    "ZF": "Yellowknife", 
    "YZF": "Yellowknife",
    "CYZF": "Yellowknife",
    "FS": "Fort Simpson",
    "WY": "Wrigley",
    "WB": "Wood Buffalo National Park",
    "WBNP": "Wood Buffalo National Park",
    "HAY": "Hay River",
    "HY": "Hay River",
    "YHY": "Hay River",
    "RAE": "Rae-Edzo",
    "RES": "Fort Resolution",
    "SK": "Sambaa Ke",
    "Sambaa K'e": "Sambaa Ke",
    "JF": "Fort Liard",
    "YJF": "Fort Liard",
    "JMR": "Jean Marie River",
    "JP": "Fort Providence",
    "YJP": "Fort Providence",
    "CYJP": "Fort Providence",
    "TSIIG": "Tsiigehtchic",
    "Liard": "Fort Liard",
    "Smith": "Fort Smith",
    "Gameti": "Gameti",
    "What-ti": "Whatì"
  },
  "province_codes": {
    "AB": "Alberta",
    "BC": "British Columbia",
    "SK": "Saskatchewan",
    "MB": "Manitoba",
    "YT": "Yukon Territory",
    "NT": "Northwest Territories",
    "NU": "Nunavut",
    "ON": "Ontario",
    "QC": "Quebec",
    "NB": "New Brunswick",
    "NS": "Nova Scotia",
    "PE": "Prince Edward Island",
    "NL": "Newfoundland and Labrador"
  },
  "area_codes": {
    "HY": "Hay River Area",
    "SM": "Fort Smith Area"
  },
  "district_codes": {
    "EV": "Inuvik District",
    "VQ": "Norman Wells District",
    "SM": "Fort Smith District",
    "ZF": "Yellowknife District",
    "FS": "Fort Simpson District",
    "CR": "Caribou Range District",
    "HY": "Hay River District"
  },
  "region_aliases": {
    "beaufort": "EV",
    "Beaufort Delta": "EV",
    "BeauDel": "EV",
    "BD": "EV",
    "sahtu": "VQ",
    "Sahtu": "VQ",
    "south slave": "SM",
    "South Slave": "SM",
    "north slave": "ZF",
    "North Slave": "ZF",
    "dehcho": "FS",
    "Deh Cho": "FS",
    "Wood Buffalo National Park": "WB",
    "WBNP": "WB"
  },
  "crew_identifiers": {
    "SS": "South Slave",
    "NS": "North Slave", 
    "DC": "Deh Cho",
    "BD": "Beaufort Delta",
    "FP": "Fort Providence",
    "Sahtu": "Sahtu",
    "Dehcho": "Deh Cho"
  },
  "status_codes": {
    "OC": "Out of Control",
    "BH": "Being Held",
    "BM": "Being Monitored", 
    "UC": "Under Control",
    "BP": "Being Prepared",
    "EX": "Extinguished"
  },
  "response_codes": {
    "AB": "Abandoned",
    "DA": "Detailed Attack",
    "IA": "Initial Attack",
    "LA": "Limited Action",
    "SA": "Suppression Action"
  },
  "wildfire_terminology": {
    "loaded patrol": "smoke patrol with crew and equipment aboard, ready for immediate deployment",
    "sk patrol": "Smoke Patrol",
    "k patrol": "Smoke Patrol",
    "TDO Call": "Territorial Duty Officer Conference Call",
    "day base": "temporary staging location (return to home base at night)",
    "taking a run": "rapid fire spread requiring immediate response",
    "fires taking a run": "rapid fire spread requiring immediate response",
    "complex": "multiple fires managed under a single incident command structure",
    "A/C": "Aircraft",
    "VAR": "Values At Risk",
    "VARs": "Values At Risk",
    "vars": "Values At Risk",
    "green staff out": "Set staff to status GREEN",
    "fuel cache": "fuel storage location",
    "demobing": "demobilizing",
    "demobed": "demobilized",
    "demob": "demobilization",
    "tied off": "control line secured at both ends, preventing fire spread around the barrier",
    "cold trail": "suppressing hot spots",
    "Fire Tech": "Fire Technician",
    "charter": "Fixed Wing Charter Flight",
    "exported": "crew transported out of operational area"
  },
  "equipment_codes": {
    "UTB": "Unit Tender Brush",
    "UTE": "Unit Tender Engine",
    "UTI": "Unit Tender Initial Attack",
    "UTS": "Unit Tender Structure",
    "UTV": "Unit Tender Village",
    "ATB": "Air Tanker Base",
    "BB4": "Pump model BB4",
    "IAS": "Initial Attack Standby",
    "U/S": "Unserviceable",
    "U/s": "Unserviceable",
    "u/s": "Unserviceable",
    "drums": "Aviation Fuel Storage Drums",
    "dozer": "Bull Dozer",
    "dozers": "Bull Dozers",
    "Dozer": "Bull Dozer",
    "Dozers": "Bull Dozers"
  },
  "fire_bases": {
    "JF base": "Fort Liard Fire Base",
    "JF Base": "Fort Liard Fire Base",
    "FS base": "Fort Simpson Fire Base",
    "FS Base": "Fort Simpson Fire Base"
  },
  "communities": {
    "Deh_Cho": [
      "Jean Marie River", "Fort Liard", "Nahanni Butte", "Fort Simpson", 
      "Wrigley", "Sambaa K'e", "Netla", "Little Doctor"
    ],
    "Sahtu": [
      "Norman Wells", "Deline", "Tulita", "Fort Good Hope", "Colville Lake"
    ],
    "Beaufort_Delta": [
      "Tsiigehtchic", "Fort McPherson", "Inuvik", "Tuktoyaktuk", 
      "Paulatuk", "Holman", "Sachs Harbour"
    ],
    "North_Slave": [
      "Wekweeti", "Yellowknife", "Whati", "Gameti", "Behchoko"
    ],
    "South_Slave": [
      "Fort Providence", "Hay River", "Enterprise", "Fort Resolution", 
      "Fort Smith", "Lutselk'e", "Kakisa"
    ]
  },
  "values_at_risk": {
    "Tloo Geeghan Camera site": "Fire monitoring camera site at Tloo Geeghan",
    "camera site": "Fire monitoring camera installation",
    "Camera site": "Fire monitoring camera installation"
  },
  "extended_terminology": {
    "cold trail": "Cold trailing is a wildfire suppression technique where firefighters use their hands to feel for heat in the ground and surrounding area to ensure a fire is completely extinguished. It's a crucial step in mop-up operations, ensuring that no hot spots remain that could reignite the fire. Crews dig and feel with their hands, sometimes removing gloves to get a better sense of the temperature, and douse any heat sources with water.",
    "dozer": "Bull Dozers are heavy equipment used in fire suppression operations for creating firebreaks, access roads, and clearing vegetation to control fire spread."
  }
};
